
// COMMENTED AT 31-10-2025
import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
//import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/resetPassword";
import ProductSelector from "./components/ProductSelector";

function App() {
  const navigate = useNavigate();
  useEffect(() => {
    // if already "logged in" token present, go to products
    const t = localStorage.getItem("token");
    if (t) {
      navigate("/product-selector");
    }
  }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<Signin />} />
      <Route path="/signin" element={<Signin />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/product-selector" element={<ProductSelector />} />
    </Routes>
  );
}

export default App;


// ADDED AT 31-10-2025
{/*
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/resetPassword";
import ProductSelector from "./components/ProductSelector";
 
function AppContent() {
  const navigate = useNavigate();
 
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/product-selector");
    }
  }, [navigate]);
 
  return (
<Routes>
<Route path="/" element={<Signin />} />
<Route path="/login" element={<Signin />} />
<Route path="/signup" element={<Signup />} />
<Route path="/forgot-password" element={<ForgotPassword />} />
<Route path="/reset-password" element={<ResetPassword />} />
<Route path="/product-selector" element={<ProductSelector />} />
</Routes>
  );
}
 
export default function App() {
  return (
<Router>
<AppContent />
</Router>
  );
} */}